import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="bg-dark-300 border-b border-saffron-500 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">

                {/* Logo */}
                <Link to="/" className="flex items-center gap-2">
                    <span className="text-saffron-500 font-display text-2xl font-bold">
                        Job<span className="text-white">Freedom</span>
                    </span>
                </Link>

                {/* Desktop Menu */}
                <div className="hidden md:flex items-center gap-8">
                    <Link to="/" className="text-gray-300 hover:text-saffron-500 transition font-medium">Home</Link>
                    <Link to="/about" className="text-gray-300 hover:text-saffron-500 transition font-medium">About</Link>
                    <Link to="/contact" className="text-gray-300 hover:text-saffron-500 transition font-medium">Contact</Link>
                    <Link to="/resume" className="text-gray-300 hover:text-saffron-500 transition font-medium">AI Resume</Link>
                    <Link to="/form/10th" className="bg-saffron-500 hover:bg-saffron-600 text-white px-6 py-2 rounded-full font-semibold transition">
                        Apply Now Free
                    </Link>
                </div>

                {/* Mobile Menu Button */}
                <button className="md:hidden text-white text-2xl" onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? '✕' : '☰'}
                </button>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden bg-dark-200 px-4 pb-4 flex flex-col gap-4">
                    <Link to="/" className="text-gray-300 hover:text-saffron-500 transition" onClick={() => setIsOpen(false)}>Home</Link>
                    <Link to="/about" className="text-gray-300 hover:text-saffron-500 transition" onClick={() => setIsOpen(false)}>About</Link>
                    <Link to="/contact" className="text-gray-300 hover:text-saffron-500 transition" onClick={() => setIsOpen(false)}>Contact</Link>
                    <Link to="/resume" className="text-gray-300 hover:text-saffron-500 transition" onClick={() => setIsOpen(false)}>AI Resume</Link>
                    <Link to="/form/10th" className="bg-saffron-500 text-white px-6 py-2 rounded-full font-semibold text-center" onClick={() => setIsOpen(false)}>Apply Now Free</Link>
                </div>
            )}
        </nav>
    );
}

export default Navbar;